import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.teams')
  .service('teamsAPI', GroupsAPI);

function GroupsAPI(): BringozApi {
  return {
    base: `/teams`,
    infiniteScroll: {
      address: `/teams`,
      cmd: 'GET'
    },
    actions: {
      createTeam: {
        address: '',
        cmd: 'PUT'
      },
      editTeam: {
        address: '{teamId}',
        cmd: 'POST'
      },
      deleteTeam: {
        address: '{teamId}',
        cmd: 'DELETE'
      },
      updateTeamAdmins: {
        address: '{teamId}/members',
        cmd: 'POST'
      },
      getTeamsAgentIds: {
        address: 'agentIds',
        cmd: 'GET'
      },
      getTeamMembersByUser: {
        address: 'byMemberBranches',
        cmd: 'POST'
      }
    }
  }
}
